import * as React from 'react';
import classNames from 'classnames';

export interface LabelProps {
  id: string;
  label: React.ReactNode | string;
  placeholderText?: React.ReactNode | string;
  className?: string;
}

function Label(props: LabelProps) {
  const { id, label, className, placeholderText } = props;

  const labelClasses = classNames(className, 'ui-label');

  return (
    <label className={labelClasses} htmlFor={id}>
      {label}
      {placeholderText && (
        <p className="ui-label-helper-text">{placeholderText}</p>
      )}
    </label>
  );
}

export default Label;
